<template>
  <div
    class="approval-review-preview"
    v-if="proofs.length === 1"
  >
    <lightbox
      v-if="selectedProof"
      :image-url="selectedProof"
      @close="() => selectedProof = null"
    />
    <img
      class="approval-review-preview__image"
      :src="proofs[0]"
      alt="proof"
      @click="selectProof"
    />
  </div>
  <slider
    v-else
    :images="proofs"
    :max="2"
  ></slider>
</template>

<script setup lang="ts">
import { ref, type Ref } from 'vue';

import Slider from '../ui/Slider.vue';
import Lightbox from '../ui/Lightbox.vue';

interface IProps {
  proofs: string[];
}
const props = defineProps<IProps>();

const selectedProof: Ref<string | null> = ref(null);

function selectProof() {
  if (props.proofs?.length) {
    selectedProof.value = props.proofs[0];
  }
}
</script>

<style scoped lang="scss">
.approval-review-preview {
  max-width: 373px;
  max-height: 373px;

  &__image {
    width: 100%;
    height: 100%;
  }
}
</style>